import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from 'srcReact/components/common2/Button'
import styles from './styles.module.scss'

export default function PendingJoinGroupApproval({ closeModal }) {
  const { t } = useTranslation()
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('mixrHome.approvalPendingTitle')}</h1>
      <h2 className={styles.subTitle}>{t('mixrHome.approvalPendingTitleText')} </h2>
      <Button type='button' size='large' text={t('global.ok')} handleClick={closeModal} />
    </div>
  )
}
